import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { IClient } from '../../../shared/interfaces/IClient';
import { ClientService } from '../../services/client.service';
import { Store } from '@ngrx/store';
import { AppState } from '../../../app.reducer';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-forgot-password-page',
  templateUrl: './forgot-password-page.component.html',
  styleUrls: ['./forgot-password-page.component.scss'],
})
export class ForgotPasswordPageComponent implements OnInit {
  forgotPasswordForm: FormGroup;
  loading = false;
  success = false;
  error = false;

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private store: Store<AppState>,
    private clientService: ClientService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.loading = true;

    this.forgotPasswordForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
    });

    this.loading = false;
  }

  forgotPassword(): void {
    if (this.forgotPasswordForm.invalid) {
      return;
    }

    this.loading = true;
    const email = this.forgotPasswordForm.value.email;
    const apiUrl = environment.apiUrl;

    this.loading = true;
    this.http.post(apiUrl + 'clients/forgotPassword', { email })
    .subscribe({
      next: (response) => {
        this.loading = false;
        this.success = true;
      },
      error: (error) => {
        this.loading = false;
        this.error = true;
      }
    });

    this.forgotPasswordForm.value.email = "";
    
  }
}
